<template>
    <div>
        <vk-tabs-vertical v-if="! isMobile()" :keep-alive="true">
            <vk-tabs-item title="DADOS PESSOAIS">
                <form class="form-horizontal" style="margin-top: 10px">
                    <div class="form-group">
                        <label for="nome" class="col-sm-2 control-label">NOME:</label>
                        <div class="col-sm-4">
                            <input type="text" :disabled="! edit" v-model="cliente.nome" class="form-control" id="nome" placeholder="Nome">
                        </div>
                        <label for="email" class="col-sm-2 control-label">E-MAIL FINANCEIRO:</label>
                        <div class="col-sm-4">
                            <input type="email" :disabled="! edit" v-model="cliente.email" class="form-control" id="email" placeholder="E-mail">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="razao_social" class="col-sm-2 control-label">RAZÃO SOCIAL:</label>
                        <div class="col-sm-4">
                            <input type="text" :disabled="! edit" v-model="cliente.razao_social" class="form-control" id="razao_social" placeholder="Razão Social">
                        </div>

                        <label for="tipo_cliente" class="col-sm-1 control-label">TIPO:</label>
                        <div class="col-sm-2">
                            <select :disabled="! edit" v-model="cliente.tipo_cliente" class="form-control" id="tipo_cliente">
                                <option value="F">FÍSICA</option>
                                <option value="J">JURÍDICA</option>
                            </select>
                        </div>

                        <label for="cpf_cnpj" v-if="cliente.tipo_cliente == 'J'"
                               class="col-sm-1 control-label">CNPJ:</label>
                        <label for="cpf_cnpj" v-else class="col-sm-1 control-label">CPF:</label>
                        <div class="col-sm-2">
                            <input type="text" :disabled="! edit" v-model="cliente.cpf_cnpj" maxlength="14" class="form-control" id="cpf_cnpj">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="cep" class="col-sm-2 col-xs-2 control-label">CEP:</label>
                        <div class="col-sm-2 col-xs-4">
                            <input type="text" :disabled="! edit" v-model="cliente.cep" v-mask="'#####-###'" maxlength="14"
                                   class="form-control" id="cep" placeholder="#####-###" >
                        </div>
                        <div class="col-sm-2 col-xs-6">
                            <button @click="getCep()" :disabled="! edit" type="button"
                                    class="btn btn-block btn-sm btn-success col-sm-1" style="padding-top: 5px">
                                <li class="fa fa-search"></li> BUSCAR</button>
                        </div>


                        <label for="nascimento" class="col-sm-2 control-label">DT NASCIMENTO:</label>
                        <div class="col-sm-2">
                            <input type="date" :disabled="! edit" v-model="cliente.nascimento" class="form-control" id="nascimento" >
                        </div>
                        <!--
                        <label for="estado" class="col-sm-2 control-label">TERMO DE BLOQUEIO:</label>
                        <div class="col-sm-2">
                            <combo-true-false :disabled="! edit" v-model="cliente.habilitar_bloqueio"></combo-true-false>
                        </div>
                        -->
                    </div>
                    <div class="form-group">
                        <label for="endereco" class="col-sm-2 control-label">ENDEREÇO:</label>
                        <div class="col-sm-7">
                            <input type="text" :disabled="! edit" v-model="cliente.endereco" class="form-control" id="endereco" placeholder="Endereço">
                        </div>
                        <label for="numero" class="col-sm-1 control-label">NÚMERO:</label>
                        <div class="col-sm-2">
                            <input type="text" :disabled="! edit" v-model="cliente.numero" class="form-control" id="numero" placeholder="Número">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="cidade" class="col-sm-2 control-label">CIDADE / IBGE:</label>
                        <div class="col-sm-4">
                            <input type="text" :disabled="! edit" v-model="cliente.cidade" class="form-control" id="cidade" placeholder="Nome da Cidade">
                        </div>
                        <div class="col-sm-2">
                            <input type="text" :disabled="! edit" v-model="cliente.cidade_ibge" class="form-control" id="cidade_ibge" placeholder="Código IBGE">
                        </div>
                        <label for="estado" class="col-sm-1 control-label">ESTADO:</label>
                        <div class="col-sm-3">
                            <select :disabled="! edit" v-model="cliente.estado" class="form-control" id="estado" >
                                <option v-for="est in estados" :value="est.value">{{est.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="complemento" class="col-sm-2 control-label">COMPLEMENTO:</label>
                        <div class="col-sm-5">
                            <input type="text" :disabled="! edit" v-model="cliente.complemento" class="form-control" id="complemento" placeholder="Complemento">
                        </div>
                        <label for="bairro" class="col-sm-1 control-label">BAIRRO:</label>
                        <div class="col-sm-4">
                            <input type="text" :disabled="! edit" v-model="cliente.bairro" class="form-control" id="bairro" placeholder="Bairro">
                        </div>
                    </div>
                </form>
            </vk-tabs-item>
            <vk-tabs-item title="FINANCEIRO" v-if="showFinanceiro">
                <form class="form-horizontal" style="margin-top: 10px">
                    <div >
                        <div class="form-group">
                            <label for="banco_id" class="col-sm-2 control-label">COBRANÇA:</label>
                            <div class="col-sm-6">
                                <combo-contas-banco :disabled="! edit" v-model="cliente.banco_id"></combo-contas-banco>
                            </div>
                            <label for="periodo_pagamento" class="col-sm-1 control-label">PERÍODO:</label>
                            <div class="col-sm-3">
                                <combo-periodo-pagamento :disabled="! edit"  v-model="cliente.periodo_pagamento"></combo-periodo-pagamento>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="vencimento" class="col-sm-2 control-label">VENCIMENTO:</label>
                            <div class="col-sm-2">
                                <input type="number" :disabled="! edit" v-model.number="cliente.vencimento" class="form-control" id="vencimento" placeholder="Vencimento">
                            </div>

                            <label for="banco_id" class="col-sm-3 control-label">DESABILITAR BLOQUEIO FINANCEIRO:</label>
                            <div class="col-sm-2">
                                <combo-true-false :disabled="! edit" v-model="cliente.desabilitar_bloqueio_automatico"></combo-true-false>
                            </div>

                        </div>

                        <div class="form-group">
                            <label for="nfe" class="col-sm-2 control-label">
                                NFS-e
                            </label>
                            <div class="col-sm-2">
                                <combo-true-false :disabled="! edit" v-model="cliente.nfe"></combo-true-false>
                            </div>

                            <label for="nfe" v-if="cliente.nfe" class="col-sm-3 text-uppercase control-label">
                                Gera NFS-e ao Registrar o Boleto
                            </label>
                            <div class="col-sm-2" v-if="cliente.nfe">
                                <combo-true-false :disabled="! edit" v-model="cliente.nfe_boleto_registrado"></combo-true-false>
                            </div>
                        </div>

                        <div class="form-group">
                            <!--
                            <label for="banco_id" class="col-sm-2 control-label">WHATSAPP COBRANÇA:</label>
                            <div class="col-sm-2">
                              <input type="text" :disabled="! edit" v-model="cliente.whatsapp_cobranca"  v-mask="'(##)#####-####'"
                                     maxlength="14" class="form-control" id="whatsapp_cobranca" placeholder="(##)#####-####">
                            </div>
                            -->

                            <label for="id_parceiro" class="col-sm-2 control-label">PARCEIRO:</label>
                            <div class="col-sm-6">
                                <combo-parceiro :disabled="! edit"  v-model="cliente.id_parceiro"></combo-parceiro>
                            </div>



                            <label for="cod_externo" class="col-sm-2 control-label">CÓDIGO EXTERNO:</label>
                            <div class="col-sm-2">
                                <input type="number" :disabled="! edit" v-model.number="cliente.cod_externo" class="form-control" id="cod_externo" >
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="acesso_cadastros" class="col-sm-2 control-label">HABILITAR DESCONTO:</label>
                        <div class="col-sm-2">
                            <combo-true-false :disabled="! edit" v-model="cliente.discount_enable"></combo-true-false>
                        </div>

                        <div v-if="cliente.discount_enable">
                            <label for="discount_type" class="col-sm-2 control-label">TIPO DE DESCONTO:</label>
                            <div class="col-sm-2">
                                <select class="form-control" :disabled="! edit" v-model="cliente.discount_type">
                                    <option value="FIXED">VALOR FIXO</option>
                                    <option value="PERCENTAGE">PORCENTAGEM</option>
                                </select>
                            </div>

                            <label for="discount_type" class="col-sm-2 control-label">VALOR DO DESCONTO:</label>
                            <div class="col-sm-2">
                                <input type="number" :disabled="! edit" v-model="cliente.discount_value" class="form-control" id="discount_type">
                            </div>
                        </div>

                    </div>


                </form>
            </vk-tabs-item>
            <vk-tabs-item title="SERVIÇOS" v-if="! isMobile()">
                <form class="form-horizontal" style="margin-top: 10px">
                    <div  class="form-group">
                        <label for="estado" class="col-sm-2 control-label">
                            TELEMETRIA.:<br/>
                        </label>
                        <div class="col-sm-2">
                            <combo-true-false :disabled="! edit" v-model="cliente.telemetria"/>
                        </div>
                    </div>
                    <div  class="form-group">
                        <label for="estado" class="col-sm-2 control-label">
                            ABASTECIMENTO.:<br/>
                        </label>
                        <div class="col-sm-2">
                            <combo-true-false :disabled="! edit" v-model="cliente.abastecimento"/>
                        </div>
                    </div>
                    <div  class="form-group">
                        <label for="estado" class="col-sm-2 control-label">
                            MANUTENÇÃO.:<br/>
                        </label>
                        <div class="col-sm-2">
                            <combo-true-false :disabled="! edit" v-model="cliente.manutencao"/>
                        </div>
                    </div>
                    <div  class="form-group">
                        <label for="estado" class="col-sm-2 control-label">
                            MULTAS.:<br/>
                        </label>
                        <div class="col-sm-2">
                            <combo-true-false :disabled="! edit" v-model="cliente.multas"/>
                        </div>
                    </div>
                </form>
            </vk-tabs-item>
        </vk-tabs-vertical>

        <vk-tabs v-else :keep-alive="true">
            <vk-tabs-item title="DADOS PESSOAIS">
                <form class="form-horizontal" style="margin-top: 10px">
                    <div class="form-group">
                        <label for="nome" class="col-sm-2 control-label label-lg">NOME:</label>
                        <div class="col-sm-4">
                            <input type="text" :disabled="! edit" v-model="cliente.nome" :class="{'input-lg': isMobile}"
                                   class="form-control input-lg" id="nome" placeholder="Nome">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="email" class="col-sm-2 control-label label-lg">E-MAIL FINANCEIRO:</label>
                        <div class="col-sm-4">
                            <input type="email" :disabled="! edit" v-model="cliente.email"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="email" placeholder="E-mail">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="razao_social" class="col-sm-2 control-label label-lg">RAZÃO SOCIAL:</label>
                        <div class="col-sm-6">
                            <input type="text" :disabled="! edit" v-model="cliente.razao_social"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="razao_social" placeholder="Razão Social">
                        </div>

                    </div>
                    <div class="form-group">

                        <label for="cpf_cnpj" class="col-sm-2 control-label label-lg">CPF / CNPJ:</label>
                        <div class="col-sm-2">
                            <input type="text" :disabled="! edit" v-model="cliente.cpf_cnpj"
                                   :class="{'input-lg': isMobile}"
                                   maxlength="20" class="form-control" id="cpf_cnpj">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="cep" class="col-sm-2 col-xs-12 control-label label-lg">CEP:</label>
                        <div class="col-sm-2 col-xs-6">
                            <input type="text" :disabled="! edit" v-model="cliente.cep"
                                   :class="{'input-lg': isMobile}"
                                   v-mask="'#####-###'" maxlength="14"
                                   class="form-control" id="cep" placeholder="#####-###" >
                        </div>
                        <div class="col-sm-2 col-xs-6">
                            <button @click="getCep()" :disabled="! edit" type="button"
                                    class="btn btn-block btn-md btn-success " style="padding-top: 5px">
                                <li class="fa fa-search"></li> BUSCAR</button>
                        </div>

                    </div>
                    <div class="form-group">

                        <label for="nascimento" class="col-sm-2 control-label label-lg">DT NASCIMENTO:</label>
                        <div class="col-sm-2">
                            <input type="date" :disabled="! edit" v-model="cliente.nascimento"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="nascimento" >
                        </div>
                        <!--
                        <label for="estado" class="col-sm-2 control-label">TERMO DE BLOQUEIO:</label>
                        <div class="col-sm-2">
                            <combo-true-false :disabled="! edit" v-model="cliente.habilitar_bloqueio"></combo-true-false>
                        </div>
                        -->
                    </div>
                    <div class="form-group">
                        <label for="endereco" class="col-xs-8 control-label label-lg">ENDEREÇO:</label>
                        <label for="numero" class="col-xs-4 control-label label-lg">NÚMERO:</label>
                        <div class="col-xs-8">
                            <input type="text" :disabled="! edit" v-model="cliente.endereco"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="endereco" placeholder="Endereço">
                        </div>

                        <div class="col-xs-4">
                            <input type="text" :disabled="! edit" v-model="cliente.numero"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="numero" placeholder="Número">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="estado" class="col-sm-1 control-label label-lg">ESTADO:</label>
                        <div class="col-sm-3">
                            <select :disabled="! edit" v-model="cliente.estado" :class="{'input-lg': isMobile}" class="form-control" id="estado" >
                                <option v-for="est in estados" :value="est.value">{{est.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="cidade" class="col-xs-8 control-label label-lg">CIDADE:</label>
                        <label for="cidade" class="col-xs-4 control-label label-lg">IBGE:</label>
                        <div class="col-xs-8">
                            <input type="text" :disabled="! edit" v-model="cliente.cidade"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="cidade" placeholder="Nome da Cidade">
                        </div>
                        <div class="col-xs-4">
                            <input type="text" :disabled="! edit" v-model="cliente.cidade_ibge"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="cidade_ibge" placeholder="Código IBGE">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="bairro" class="col-sm-1 control-label label-lg">BAIRRO:</label>
                        <div class="col-sm-4">
                            <input type="text" :disabled="! edit" v-model="cliente.bairro"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="bairro" placeholder="Bairro">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="complemento" class="col-sm-2 control-label label-lg">COMPLEMENTO:</label>
                        <div class="col-sm-5">
                            <input type="text" maxlength="105" :disabled="! edit" v-model="cliente.complemento"
                                   :class="{'input-lg': isMobile}"
                                   class="form-control" id="complemento" placeholder="Complemento">
                        </div>
                    </div>

                </form>
            </vk-tabs-item>
            <vk-tabs-item title="FINANCEIRO" v-if="showFinanceiro">
                <form class="form-horizontal" style="margin-top: 10px">
                    <div >
                        <div class="form-group">
                            <label for="banco_id" class="col-sm-2 control-label label-lg">COBRANÇA:</label>
                            <div class="col-sm-6">
                                <combo-contas-banco :class="{'input-lg': isMobile}"
                                                    :disabled="! edit" v-model="cliente.banco_id"/>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="periodo_pagamento" class="col-xs-8 control-label label-lg">PERÍODO:</label>
                            <label for="vencimento" class="col-xs-4 control-label label-lg">VENCIMENTO:</label>

                            <div class="col-xs-8">
                                <combo-periodo-pagamento :disabled="! edit" :class="{'input-lg': isMobile}"
                                                         v-model="cliente.periodo_pagamento"/>
                            </div>

                            <div class="col-xs-4">
                                <input type="number" :disabled="! edit" :class="{'input-lg': isMobile}"
                                       v-model.number="cliente.vencimento" class="form-control" id="vencimento" placeholder="Vencimento">
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="nfe" class="col-sm-2 control-label label-lg">
                                NFS-e
                            </label>
                            <div class="col-sm-2">
                                <combo-true-false :disabled="! edit" v-model="cliente.nfe"
                                                  :class="{'input-lg': isMobile}"/>
                            </div>

                            <label for="nfe" class="col-sm-3 label-lg text-uppercase control-label">
                                Gera NFS-e ao Registrar o Boleto
                            </label>
                            <div class="col-sm-2">
                                <combo-true-false :disabled="! edit" v-model="cliente.nfe_boleto_registrado"
                                                  :class="{'input-lg': isMobile}"/>
                            </div>
                        </div>

                        <div class="form-group">

                            <label for="id_parceiro" class="col-sm-2 control-label label-lg ">PARCEIRO:</label>
                            <div class="col-sm-6">
                                <combo-parceiro :disabled="! edit" :class="{'input-lg': isMobile}" v-model="cliente.id_parceiro"></combo-parceiro>
                            </div>

                        </div>
                    </div>

                </form>
            </vk-tabs-item>
        </vk-tabs>
    </div>
</template>

<script>
    import { Utils } from '../../class';
    import ComboContasBanco from "../combos/ComboContasBanco";
    import ComboTrueFalse from "../combos/ComboTrueFalse";
    import ComboParceiro from "../combos/ComboParceiros";
    import ComboPeriodoPagamento from "../combos/ComboPeriodoPagamento";
    import {isMobile} from '../../utils/is-celular';

    export default {
        name: "FormCliente",
        props: {
            cliente: {
                default: null
            },
            edit: {
                type: Boolean,
                default: true
            },
            showFinanceiro: {
              default: true
            },
        },
        components: {
            ComboPeriodoPagamento,
            ComboParceiro,
            ComboContasBanco, ComboTrueFalse
        },
        data(){
            return {
                estados: Utils.estados()
            }
        },
        methods: {
            isMobile() {
                return isMobile()
            },
            getCep(){

                this
                    .$http
                    .get("https://viacep.com.br/ws/" + this.cliente.cep + "/json/")
                    // .get('cep/' + this.cliente.cep)
                    .then((row) => {
                        this.cliente.cidade = row.body.localidade;
                        this.cliente.bairro = row.body.bairro;
                        this.cliente.estado = row.body.uf;
                        this.cliente.cidade_ibge = row.body.ibge;
                        if (row.body.logradouro) {
                            this.cliente.endereco = row.body.logradouro;
                        } else {
                            this.cliente.endereco = null;
                        }
                    })
                    .catch((err) => console.log(err));

            },
        }
    }
</script>
